import { render, staticRenderFns } from "./ChairmansClub.vue?vue&type=template&id=33d88408&scoped=true&"
import script from "./ChairmansClub.vue?vue&type=script&lang=js&"
export * from "./ChairmansClub.vue?vue&type=script&lang=js&"
import style0 from "./ChairmansClub.vue?vue&type=style&index=0&id=33d88408&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d88408",
  null
  
)

export default component.exports